import React from 'react'
import s from './component.module.scss'

const Preloader = (props) => {
   return <div className={s.loader} id="loader" >Loading...</div>
}

export default Preloader